//import { AllowOperations } from './../../../../core/interfaces/1portfolio.interface';
//import { portfolioInterface } from '@techrules/portallib';

import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { ActivitiesService, OperativeService } from '@techrules/portallib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalPartialdepositComponent } from '../modal-partialdeposit/modal-partialdeposit.component';

@Component({
  selector: 'tech-modal-partialwithdrawal',
  templateUrl: './modal-partialwithdrawal.component.html',
  styleUrls: ['./modal-partialwithdrawal.component.scss']
})

export class ModalPartialwithdrawalComponent implements OnInit {
  portfolioCode: string;
  activityId:string;
  private unsubscribe$ = new Subject<void>();
  private allowOperations: any;
  isOpen = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private activityservice: ActivitiesService,
    private dialogRef: MatDialogRef<ModalPartialdepositComponent>,
    private profileportfolioService: ProfileportfolioService,
  ) {
    this.portfolioCode = dataDialog.portfolioCode;
    this.activityId = dataDialog.activityId;

    this.profileportfolioService.portfolioData$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any) => {
      // console.log(data);
      this.allowOperations = data.AllowOperations;
    });

  }

  ngOnInit() {
  }

  deletepartialW()
  {
    this.deletewithdrawall();
  }

  public deletewithdrawall(){
    this.activityservice.activitiesWithdrawal(this.portfolioCode, this.activityId).subscribe((data) => {
      console.log("canceladowithdrawal");
      this.allowOperations.AllowWithdrawal = true;
      this.allowOperations.AllowContribution = true;
      this.dialogRef.close();
    });
  }
}
